module.exports = __webpack_public_path__ + "img/logo_456.54d6444d.png";